<div *ngIf="(user$ | async) === null" class="main-div">
  <mat-card appearance="outlined" class="card">
    <mat-card-header>
      <mat-card-title>Bem vindo(a)</mat-card-title>
      <mat-card-subtitle class="card-subtitle">Efetue login para acessar o sistema</mat-card-subtitle>
    </mat-card-header>
    <mat-card-actions class="card-button">
      <button mat-raised-button color="primary" (click)="login()">Entrar usando Central de Acessos</button>
    </mat-card-actions>
  </mat-card>
</div>

<div *ngIf="user$ | async" style="display: flex; flex-direction: column">
  <div style="display: flex; flex-wrap: wrap; justify-content: center; align-items: center">
    <mat-card appearance="outlined" class="card">
      <mat-card-header>
        <mat-card-title> Olá, {{ userLogin?.nomeUsuario }} </mat-card-title>
        <mat-card-subtitle>Utilize o menu para acessar as funcionalidades</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <app-perfil-selecionar></app-perfil-selecionar>
      </mat-card-content>
    </mat-card>
  </div>
</div>
